/*
 * Marquee announcement rotator.
 *
 * The bar can carry two messages. Instead of fading between them, the swap is
 * applied on an `animationiteration` boundary: at that instant the track has
 * just reset to its start position, so exchanging the visible track is a clean
 * cut rather than a jump part-way through the scroll.
 *
 * Because of that, the configured interval is rounded to the nearest whole
 * number of scroll loops. With the theme defaults one loop is 30s and the
 * interval is 30s, so they line up exactly.
 */
(function () {
  function loopDurationMs(element) {
    var duration = getComputedStyle(element).animationDuration || '';
    var value = parseFloat(duration);

    if (!value) return 0;

    return duration.indexOf('ms') === -1 ? value * 1000 : value;
  }

  function init(bar) {
    if (bar.dataset.marqueeRotatorReady === 'true') return;

    var wrapper = bar.querySelector('.marquee-announcement-bar__wrapper');
    var tracks = bar.querySelectorAll('[data-marquee-track]');

    if (!wrapper || tracks.length < 2) return;

    bar.dataset.marqueeRotatorReady = 'true';

    var intervalMs = (parseFloat(bar.dataset.marqueeInterval) || 30) * 1000;
    var current = 0;

    function advance() {
      current = (current + 1) % tracks.length;

      for (var i = 0; i < tracks.length; i++) {
        tracks[i].hidden = i !== current;
      }
    }

    var loopMs = loopDurationMs(wrapper);

    // Nothing is animating (print, or a browser with animations switched off),
    // so there is no scroll to stay in step with. Swap on a plain timer.
    if (!loopMs) {
      setInterval(advance, intervalMs);
      return;
    }

    var loops = 0;

    wrapper.addEventListener('animationiteration', function () {
      loops++;

      // Re-read each time: the mobile breakpoint scrolls faster, so the loop
      // length changes when the viewport crosses it.
      var needed = Math.max(1, Math.round(intervalMs / (loopDurationMs(wrapper) || loopMs)));

      if (loops >= needed) {
        loops = 0;
        advance();
      }
    });
  }

  function initAll() {
    var bars = document.querySelectorAll('[data-marquee-rotator]');

    for (var i = 0; i < bars.length; i++) {
      init(bars[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
